module.exports = __webpack_public_path__ + "static/img/cor_logo2_home_nor.9e406b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cor_logo2_home_nor.png
// module id = 4eQ5
// module chunks = 26